import { USER_ROLE } from './enums/userRole'

export enum USER_STATUS {
    AWAITING = 'AWAITING',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export interface IUserManagement {
    id: number
    name: string
    email: string
    role: USER_ROLE
    status: USER_STATUS
    creci?: string
    estateAgency?: string
    phone?: string
    cpf?: string
}
